<div class="input-component" [ngClass]="{'valid': !invalid, 'invalid': invalid}">
    <div class="input-wrapper">
        <!-- <dropzone [message]="'Click or drag files here to attach'" class="dropzone" [useDropzoneClass]="false" (error)="onUploadError($event)"
                  (success)="onUploadSuccess($event)"></dropzone> -->
    </div>
</div>
